// Default template parameters
export const defaultTemplateParams = {
  headerBgColor: 'transparent',
  logoUrl: '',
  heroImgUrl:
    'https://dev-cdn.savibook.com/widget/08d70c6e-a338-7b41-f362-8ca7ac7799dc/0/email-hero-11.jpg',
  preheaderText: 'This text will appear next to your subject line in the inbox.',
  subject: 'This is the email subject',
  emailTitle: 'Your Next Stay Awaits',
  ctaText: 'Book your next stay',
  ctaBackgroundColor: 'transparent',
  hotelName: 'Kailani Resorts - New York',
  hotelAddress: '123 Apple St',
  hotelCityStateZip: 'New York, NY 10002',
  privacyPolicyUrl: '#',
  termsUrl: '#',
  socialMediaLinks: [
    { platform: 'facebook', url: '#' },
    { platform: 'twitter', url: '#' },
    { platform: 'instagram', url: '#' },
    { platform: 'linkedin', url: '#' },
    { platform: 'youtube', url: '#' }
  ],
  ctaTextColor: 'transparent',
  richtextFields: {
    bodyHtml:
      'Hello  :token{key="guestName" label="First name"} :token{key="guestLastName" label="Last name"},\n\nWe hope you enjoyed your recent stay with us on :token{key="checkoutDate" label="Checkout date"}. We\'d love to have you back soon!\n\nBook directly through our website and enjoy **15% off** your next visit, plus **free late checkout**.'
  },
  logoWidth: '60px',
  logoHeight: '60px'
}

export default defaultTemplateParams
